// extracted by mini-css-extract-plugin
export var animationContainer = "_gx-0";
export var asteriskIcon = "_gx-8";
export var conversationLeftSection = "_gx-4";
export var conversationListItem = "_gx-3";
export var conversationMiddleSection = "_gx-5";
export var conversationRightSection = "_gx-6";
export var detailsContent = "_gx-1";
export var listContainer = "_gx-7";
export var modalContent = "_gx-2";